import { z } from 'zod'
import { AdminPermission } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import { type QuickMdState } from '@/app/store'
import { useAppSelector } from '@/redux/hooks/useAppSelector'

/**
 * The logged-in admin's profile (`GET /api/v1/profile`) is stored untyped in the
 * legacy Redux slice, so we narrow the only field we care about at the boundary.
 */
const ProfilePermissionsSchema = z.object({
  Permissions: z.array(z.string()).nullish(),
})

const selectAdminProfile = (state: QuickMdState) => state.accountSettings.adminProfile

/** True when the logged-in admin holds the `admin.permissions.manage` permission. */
export function useCanManagePermissions(): boolean {
  const adminProfile = useAppSelector(selectAdminProfile)
  const result = ProfilePermissionsSchema.safeParse(adminProfile)
  if (!result.success) return false
  return result.data.Permissions?.includes(AdminPermission.adminpermissionsmanage) ?? false
}
